import { render, staticRenderFns } from "./setPasswordRecovery.vue?vue&type=template&id=b3b887e0&scoped=true"
import script from "./setPasswordRecovery.vue?vue&type=script&lang=js"
export * from "./setPasswordRecovery.vue?vue&type=script&lang=js"
import style0 from "./setPasswordRecovery.vue?vue&type=style&index=0&id=b3b887e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b887e0",
  null
  
)

export default component.exports